import $ from "jquery";
import Tab from "DMS/Seed/Seed.Tab";
import * as lib from "DMS/Utils/lib";
/**
 * Print a message before unload the tab
 * @returns {string} Message to send if a required input is empty,
 */
export function onBeforeUnload() {
    if (!checkRequiredFieldInCurrentModule()) {
        return MSG_REQUIRED_FIELD_ONBEFOREUNLOAD;
    }
}
/**
 * Check if there is a required field empty in this module
 * @returns {Boolean} Returns true if a field required is empty
 */
export function checkRequiredFieldInCurrentModule(moduleName, currentTab) {
    let foundRequired = false;
    //Tout d'abord on check les formulaires ouverts sur le module courant
    if (typeof currentTab !== "undefined") {
        // On fait d'abord un check de tout les formulaires affiché dans
        // le module courant
        $('#' + moduleName + '_tab').find('.Seed_Tab').each(function () {
            let tab = $('#' + this.id.replace('link', 'tab'));
            if (tab.find('.k-grid').length == 0) {
                // Si l'onglet courant ne contient pas de liste,
                // c'est un formulaire.
                if (!checkRequiredFields(this.id.replace('link_', ''))) {
                    foundRequired = true;
                    return false;
                }
            }
        });
    }
    return !foundRequired;
}
/**
 * Verifie les champs requis dans le formulaire courant
 * @param {type} idTab ID de l'onglet à vérifier
 * @returns {Boolean} TRUE si tout va bien | FALSE si au moins un champs
 *  obligatoire est oublié
 */
export function checkRequiredFields(idTab) {
    var findEmpty = false;
    var frame;
    if (!lib.empty(idTab)) {
        frame = $("#tab_" + idTab);
    }
    else {
        frame = Seed.Tab.GetFrame();
    }
    //On cherche tout les champs requis dans la frame courante
    frame.find('.requiredField').find('input, select, textarea').each(function () {
        let parent = $(this).parents('.requiredField')[0];
        //Verification si le champ est modifiable et s'il est displayed (champs obligatoires cachés par visiblecontext)
        if ($(this).attr('readonly') !== 'readonly'
            && $(this).attr('disabled') !== 'disabled'
            && $(parent).css('display') !== 'none') {
            //Si la valeur du champ est vide
            if (lib.empty(lib.trim($(this).val()))) {
                findEmpty = this;
                return false;
            }
        }
    });
    if (findEmpty !== false) {
        if (!confirm(MSG_REQUIRED_FIELD)) {
            //Si l'onglet a supprimer n'est pas l'onglet courant, on renvois dessus
            if (!lib.empty(idTab) && Tab.aActive[Tab.CurrentModule] != idTab) {
                Tab.linkClick($('#link_' + idTab), true);
            }
            $(findEmpty).parents('section').get().scrollIntoView();
            $(findEmpty).tooltip({
                title: 'Champ requis',
                trigger: 'focus',
                container: 'body'
            });
            $(findEmpty).focus();
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=requiredField.js.map